import React, { Component } from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
import { withStyles } from "@material-ui/core/styles";

import SearchTab from "../../granular/Leftpanel/monitoring";
import Tracking from "../../granular/Leftpanel/tracking";
import Zonatracking from "../../granular/Leftpanel/zonatracking";
import ChangeDest from "../../granular/Leftpanel/changedest";
import Jumping from "../../granular/Leftpanel/jump";
import Draugh from "../../granular/Leftpanel/draugh";
import Speed from "../../granular/Leftpanel/speed";
import Fraud from "../../granular/Leftpanel/fraud";
import IncompleteInfo from "../../granular/Leftpanel/incompleteinfo";
import Inactive from "../../granular/Leftpanel/inactive";
import IdleClose from "../../granular/Leftpanel/idleclose";
import VesselPosision from "../../granular/Leftpanel/vesselposision";
import { withRouter } from "react-router-dom";

const styles = theme => ({
  title: {
    textAlign: "center",
    flex: 1,
    fontSize: "32px",
    fontWeight: 500
  }
});

class Monitoring extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userlevel: localStorage.getItem("userlevel")
    };
  }

  UNSAFE_componentWillMount() {}

  getFraud = () => {
    if (this.state.userlevel == 3) {
      return false;
    } else {
      return {
        tabButton: "Fraud Detection",
        tabContent: (
          <div>
            <Fraud />
          </div>
        )
      };
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ justifyContent: "center" }}>
            <Typography className={classes.title}>Monitoring</Typography>
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="info"
              value={100}
              style={{ width: "20%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
          </div>
        </GridItem>
        <Grid item xs={12}>
          <Grid container justify="center" spacing={2}>
            <GridItem xs={12} md={10}>
              <NavPills
                color="blue"
                alignCenter={true}
                tabs={[
                  {
                    tabButton: "Vessel Position",
                    tabContent: (
                      <div>
                        <VesselPosision />
                      </div>
                    )
                  },
                  /*{
                    tabButton: "Vessel Tracking",
                    tabContent: (
                      <div>
                        <Tracking />
                      </div>
                    )
                  },*/
                  {
                    tabButton: "Zone Tracking",
                    tabContent: (
                      <div>
                        <Zonatracking />
                      </div>
                    )
                  },
                  {
                    tabButton: "Inactive",
                    tabContent: (
                      <div>
                        <Inactive />
                      </div>
                    )
                  },
                  {
                    tabButton: "Approach Vessel",
                    tabContent: (
                      <div>
                        <IdleClose />
                      </div>
                    )
                  },
                  {
                    tabButton: "Jumping Vessel",
                    tabContent: (
                      <div>
                        <Jumping />
                      </div>
                    )
                  },
                  {
                    tabButton: "Draught Change",
                    tabContent: <Draugh />
                  },
                  {
                    tabButton: "Speed Alert",
                    tabContent: (
                      <div>
                        <Speed />
                      </div>
                    )
                  },
                  this.getFraud()
                  // {
                  //   tabButton: "Fraud Detection",
                  //   tabContent: (
                  //     <div hidden={true}>
                  //       <Fraud />
                  //     </div>
                  //   )
                  // }
                ]}
              />
            </GridItem>
          </Grid>
        </Grid>
      </GridContainer>
    );
  }
}

export default withRouter(withStyles(styles)(Monitoring));
